import React, {useEffect, useRef, useState} from 'react';
import {Col, Row} from 'react-bootstrap';
import {useAppContext} from 'contexts/AppContext';
import {isCustomerAdmin, isLocationAdmin, isSiteAdmin, isSystemRole,
} from 'utils/Auth';
import {loadCraneSystems, loadCustomers, loadLocations, loadSites} from 'utils/Ui';
import UserDetails from './UserDetails';
import UsersFilters from './UsersFilters';
import UsersList from './UsersList';

export default function Users(props) {
    const isMounted = useRef(false);
    const {setMenuItem, setPageTitle, handleApiError} = useAppContext();
    const [isEditMode, setIsEditMode] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [filters, setFilters] = useState({limit: 25, offset: 0, order_by: 'username', order_asc: true});
    const [user, setUser] = useState({});
    const [customers, setCustomers] = useState({});
    const [sites, setSites] = useState({});
    const [locations, setLocations] = useState({});
    const [craneSystems, setCraneSystems] = useState({});
    const useCustomer = isSystemRole();
    const useSite = isSystemRole() || isCustomerAdmin();
    const useLocation = isSystemRole() || isCustomerAdmin() || isSiteAdmin();
    const useCraneSystem = isSystemRole() || isCustomerAdmin() || isSiteAdmin() || isLocationAdmin();

    useEffect(() => {
        isMounted.current = true;
        setMenuItem('/app/users');
        setPageTitle('Users');
        if (useCustomer) loadCustomers(setCustomers, handleApiError);
        if (useSite) loadSites(setSites, handleApiError);
        if (useLocation) loadLocations(setLocations, handleApiError);
        if (useCraneSystem) loadCraneSystems(setCraneSystems, handleApiError);
        return () => isMounted.current = false;
    }, []);

    const handleAddClick = () => {
        setUser({});
        setIsEditMode(true);
    };

    const handleEditClick = (user) => {
        setUser(user);
        setIsEditMode(true);
    };

    const handleCloseClick = () => setIsEditMode(false);

    if (isEditMode) return (
        <UserDetails
          user={user}
          useCustomer={useCustomer}
          useSite={useSite}
          useLocation={useLocation}
          useCraneSystem={useCraneSystem}
          customers={customers}
          sites={sites}
          locations={locations}
          craneSystems={craneSystems}
          onCloseClick={handleCloseClick}
        />
    );
    return (
        <div className="content">
            <Row>
                <Col md="12">
                    <UsersFilters
                      useCustomer={useCustomer}
                      useSite={useSite}
                      useLocation={useLocation}
                      customers={customers}
                      sites={sites}
                      locations={locations}
                      isLoading={isLoading}
                      setFilters={setFilters}
                    />
                </Col>
            </Row>
            <UsersList
              filters={filters}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              onAddClick={handleAddClick}
              onEditClick={handleEditClick}
            />
        </div>
    );
}
